const VerifiedBadge = () => {
  return (
    <span className='badge badge-light-success fs-7 fw-bold  mx-2'>
      <i className='bi bi-check2-circle text-success fw-bold'></i> verified
    </span>
  );
};

export default VerifiedBadge;
